import Vue from 'vue';
import { mapGetters } from 'vuex';
import stringify from 'json-stringify-pretty-compact';
import jsonminify from 'jsonminify';
import { guid } from '@/mixins/guid';
import tooltip from '@/mixins/components/tooltip';
import dropsLoader from '@/mixins/components/drops-loader';

export default Vue.component('storm-account-raw', {
  template: require('./template.html'),
  name: 'storm-account-raw',
  mixins: [guid],
  components: {
    dropsLoader,
    tooltip,
  },
  computed: {
    ...mapGetters(['currentUser', 'stormUser']),
    allowed() {
      return (this._storm && this.stormUser && this.stormUser.type === 'admin') || this._dev;
    },
  },
  data() {
    return {
      loading: false,
      loadError: false,
      rawData: '',
      initialData: '',
      rawJSON: {},
      accountJSON: {},
    };
  },
  created() {
    if (this.allowed || this._dev) {
      this.setInitialValues();
    }
  },
  methods: {
    async setInitialValues() {
      this.loading = true;
      this.loadError = false;
      try {
        const user = await this.$lightning([{ name: 'getCurrentUser' }]);
        this.rawJSON = user;
        this.accountJSON = user;
        this.rawData = stringify(user);
        this.initialData = this.rawData;
      } catch (e) {
        const message = e.message || e;
        this.loadError = message;
        this.$log.error(message);
      } finally {
        this.loading = false;
      }
    },
    validateJSON(dump) {
      return new Promise((resolve, reject) => {
        try {
          JSON.parse(dump);
          if (dump === '' || dump === '"{}"') {
            throw new Error('Input cannot be empty.');
          }
          resolve(true);
        } catch (e) {
          reject(e.message || e);
        }
      });
    },
    async saveRawAccount() {
      if (this.allowed || this._dev) {
        this.loading = true;
        let type = 'success';
        let message = 'Raw account data saved successfully!';
        try {
          const dump = jsonminify(this.rawData);
          await this.validateJSON(dump);
          await this.$lightning([{
            name: 'saveRawAccount',
            payload: {
              accountId: this.currentUser._id,
              dump,
            },
          }]);
        } catch (e) {
          message = e.message || e;
          type = 'error';
          this.$log.error(message);
        } finally {
          this.loading = false;
          this.$store.dispatch('addNotification', {
            id: this.guid(),
            type,
            message,
          });
        }
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/storm/admin/account-raw/index.js